export const dateFilter = function(value) {
    if (value) {
        var d = new Date(value);
        return d.toLocaleDateString();
    }
}



// WEBPACK FOOTER //
// ./src/filters/filters.js